import { render, staticRenderFns } from "./editTermsAndConditions.vue?vue&type=template&id=6a77ed89&scoped=true&"
import script from "./editTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./editTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a77ed89",
  null
  
)

export default component.exports